'use client';

import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Link } from "@argo/ui-elements";
import { typography, colors, size, breakpoints } from "@argo/principles";
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
const CopyrightContainer = styled('div')`
    ${typography.types.bodySmall};
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    color: ${colors.primary.white};
    align-items: center;
    justify-content: flex-start;
    line-height: 24px;
    margin-top: ${props => props.enableOneTrust ? '16px' : '0'};

    > span {
        margin: 0 0 ${size.sm}px 0;

        @media (min-width: ${breakpoints.md}px) {
            margin: 0 ${size.xs}px ${size.xs}px 0;
        }
    }

    @media (min-width: ${breakpoints.md}px) {
        justify-content: center;
    }
`;
const CopyrightLinks = styled.div`
    display: flex;
    flex-wrap: wrap;

    > a {
        white-space: nowrap;
        padding: 12px 0;
        margin: 0 0 ${size.xs}px 0;
    }

    @media (min-width: ${breakpoints.md}px) {
        text-align: center;
        justify-content: center;
    }
`;
const Divider = styled.span`
    margin: 12px ${size.xs}px;
`;
const NoneLink = styled.span`
    margin: 12px 0;
`;
function getWindowFunctionByPath(path) {
  if (!path) return undefined;
  return path.split('.').reduce((obj, key) => obj && obj[key] ? obj[key] : undefined, window);
}
function handleCopyrightLinkClick(e, link, triggerAnalytics) {
  if (triggerAnalytics) {
    const analyticsFn = triggerAnalytics({
      googleTag: link?.googleTag,
      pixallTag: link?.pixallTag
    });
    if (typeof analyticsFn === 'function') {
      analyticsFn();
    }
  }
  if (typeof window !== 'undefined' && link.javascriptFunc) {
    const func = getWindowFunctionByPath(link.javascriptFunc);
    if (typeof func === 'function') {
      e.preventDefault();
      func();
    }
  }
}
function handleManageCookiesClick(e, triggerAnalytics) {
  e.preventDefault();
  if (typeof window !== "undefined" && window.OneTrust) {
    const analyticsFn = triggerAnalytics && triggerAnalytics({
      googleTag: 'text-link::manage-cookies',
      pixallTag: 'text-link::manage-cookies'
    });
    if (typeof analyticsFn === 'function') {
      analyticsFn();
    }
    window?.caiprivacy?.manageCookies();
    OneTrust?.ToggleInfoDisplay();
  }
}
const Copyright = ({
  links,
  triggerAnalytics,
  enableOneTrust
}) => {
  const currentYear = useMemo(() => new Date().getFullYear(), [new Date()]);
  return React.createElement(CopyrightContainer, {
    enableOneTrust: enableOneTrust
  }, React.createElement("span", null, "\xA9 1995-", currentYear, " Kelley Blue Book Co.\xAE, Inc. All rights reserved."), React.createElement(CopyrightLinks, null, links && links.map((link, i) => [link.url && link.url.length > 1 ? React.createElement(Link, {
    key: i,
    "data-automation": link.omnitureTag,
    "data-partner": link.partnerLink,
    "data-tag-id": `copyrightLinks${i}`,
    onClick: e => handleCopyrightLinkClick(e, link, triggerAnalytics),
    rel: link?.rel || null,
    href: `${GLOBALNAV_KBB_BASE_URL}${link.url}`,
    type: 'unstyled',
    dangerouslySetInnerHTML: {
      __html: link.name
    }
  }) : React.createElement(NoneLink, {
    key: i,
    "data-tag-id": `copyrightLinks${i}`
  }, link.name), i !== links.length - 1 && React.createElement(Divider, {
    key: `a${i}`
  }, "|")]), enableOneTrust && React.createElement(React.Fragment, null, React.createElement(Divider, null, "|"), React.createElement(Link, {
    "data-automation": 'managecookies_footer',
    onClick: e => handleManageCookiesClick(e, triggerAnalytics),
    "data-tag-id": `copyrightLinks7`,
    href: '/',
    type: 'unstyled'
  }, "Manage Cookies"))));
};
Copyright.displayName = 'Copyright';
export default Copyright;